import { render, staticRenderFns } from "./GerarNovaSenha.vue?vue&type=template&id=a603afe8&scoped=true"
import script from "./GerarNovaSenha.vue?vue&type=script&lang=js"
export * from "./GerarNovaSenha.vue?vue&type=script&lang=js"
import style0 from "./GerarNovaSenha.vue?vue&type=style&index=0&id=a603afe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a603afe8",
  null
  
)

export default component.exports